// eLab laboratory ordering (KIN-1390).

// sessionStorage key holding the internal lab order id awaiting confirmation
// across the Healthlink Integrated Browser round trip. Healthlink drops our
// redirectUrl query params on the way back (it returns only its own
// ?controlId), so we carry our own id here — it survives the same-tab
// navigation and is read back on return. Same approach as referrals.
export const PENDING_IB_LAB_ORDER_KEY = "kinesin-ib-pending-lab-order-id";

export const IB_RETURN_MAX_ATTEMPTS = 3;
export const IB_RETURN_RETRY_DELAY_MS = 2000;

export const ROWS_OPTIONS = [10, 20, 50, 100];

export const SORT_OPTIONS = [
  { field: "newest-first", direction: "", label: "Newest first" },
  { field: "oldest-first", direction: "", label: "Oldest first" },
];

// The single status a GP acts on, derived from the two independent facts the
// backend reports — see utils/labOrderStatus.js.
export const LAB_ORDER_STATUS = {
  awaitingCompletion: "awaitingCompletion",
  submitted: "submitted",
  accepted: "accepted",
  rejected: "rejected",
  removedFromWorklist: "removedFromWorklist",
};

// Tones rather than colours: features/healthlink/utils/healthlinkStatusTone owns the
// palette and the app's shared Pill renders it, so a lab order and a referral cannot
// disagree about what a status looks like.
export const LAB_ORDER_STATUS_CONFIG = {
  [LAB_ORDER_STATUS.awaitingCompletion]: {
    label: "Awaiting completion",
    tone: "pending",
  },
  [LAB_ORDER_STATUS.submitted]: {
    label: "Submitted",
    tone: "neutral",
  },
  [LAB_ORDER_STATUS.accepted]: {
    label: "Accepted",
    tone: "positive",
  },
  [LAB_ORDER_STATUS.rejected]: {
    label: "Rejected",
    tone: "negative",
  },
  [LAB_ORDER_STATUS.removedFromWorklist]: {
    label: "Removed from work list",
    tone: "negative",
  },
};
